



























































































































































































































































































































































































































import {Component} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import BannerBox from "@/components/layout/BannerBox.vue";
import api from "@/api/api";
import LoadingLogo from "@/components/layout/LoadingLogo.vue";
import ProductCard from "@/helpers/mixins/ProductCard";
import LoginPanel from "@/components/Home/LoginPanel.vue";
import Link from "@/components/External/Link.vue";
import ImgLink from "@/components/External/ImgLink.vue";
import NewsList from "@/components/Home/NewsList.vue";
import CouponBox from "@/components/Home/CouponBox.vue";
import NewGoodsBanner from "@/components/Home/NewGoodsBanner.vue";
import FlashLinks from "@/helpers/mixins/flashLink"
import ScrollToLoad from "@/helpers/mixins/ScrollToLoad";
import {constants} from "@/helpers/constants"
import { SpecialThemeData } from "@/helpers/interfaces"
import ProductListItem from "@/components/External/ProductListItem.vue";

@Component({
  components: { NewGoodsBanner, Link, BannerBox, LoadingLogo, LoginPanel, ImgLink, NewsList, CouponBox, ProductListItem}
})
export default class Home extends mixins(FlashLinks, ProductCard, ScrollToLoad) {
  public langPath = "Home."
  public articleType = constants.articleType
  public recommendList = [] as object[];
  public channelCat = [] as object[];
  public channelList = [] as object[];
  public isLoading = false
  public categoryList = [] as object[]
  public chosenStore = [] as object[]
  public slideList = [] as object[];
  public specialThemeList = [] as SpecialThemeData[]
  public hotTop = {} as SpecialThemeData
  public tryNew = {} as SpecialThemeData
  public specialDiscount = {} as SpecialThemeData
  public yangtaoSpecial = {} as SpecialThemeData
  public sameAsCelebrity = {} as SpecialThemeData
  public globalCuisine = {} as SpecialThemeData
  public goodBargains = {} as SpecialThemeData
  public buyersSelection = {} as SpecialThemeData
  public groupBuy = {} as SpecialThemeData
  public shippingFree = {} as SpecialThemeData
  public mustBuy = {} as SpecialThemeData
  public chooseGoodness = {} as SpecialThemeData
  public brandList = [] as object[]
  public itemCountPerLoading = 5
  public SIDE_PANEL_DEFAULT_OBJECT = {
    linkImage: '',
    linkTarget: '',
    linkText: '',
    openInNewTab: '',
    sort: 1,
  }
  public rightPanelImages = Array(4).fill(this.SIDE_PANEL_DEFAULT_OBJECT)

  async created(){
    await this.getCategoryList()
    await this.getHomePageData()
    await this.getHomeBrand()
    await this.getChosenStore()
    await this.getRecommendedThemes()
    await this.getRecommendedItems()
  }

  public convertGroupIds(ids: any){
    let k = ids.toString()
    if(k !==""){
      k = k.replace(/,/g, '-')
    }
    return k
  }

  public async getHomePageData(){
    try {
      const res = await api.getHomeRecommendations(10)
      const response = await api.getRightPanelImgs()
      this.slideList = res.data.homeBannerList.sort(function (a, b){
        return a.sort - b.sort
      }) ||[]
      this.rightPanelImages = response.data||[]
    } catch (e) {
      this.isLoading = false
      console.log(e)
    }
  }

  addNewDataList() {
    const idx = this.itemPageIndex
    const count = this.itemCountPerLoading
    const start = idx*count
    const end = (idx+1)*count
    const tempArray = this.allDataList.slice(start, end)
    this.displayedDataList = [...this.displayedDataList, ...tempArray]
    this.itemPageIndex += 1
  }

  public async getRecommendedItems(){
    try {
      const recommendData  =  await api.getRecommendProducts(this.itemCountPerLoading)
      this.allDataList = recommendData.data||[]
      this.addNewDataList();
    }catch (e){
      this.isLoading = false
      console.log(e)
    }
  }


  public async getCategoryList(){
    try {
      const res = await api.getLeftMenu()
      this.categoryList = res.data.dataList ||[]
    }catch (e){
      this.isLoading = false
      console.log(e)
    }
  }

  public async getChosenStore(){
    const query = {
      storeCount: 2,
      skuCount: 3
    }
    try {
      const res = await api.getChosenStoreHome(query.storeCount, query.skuCount)
      this.chosenStore = res.data || []
    }catch (e){
      this.isLoading = false
      console.log(e)
    }
  }

  public async getRecommendedThemes(){
    const data = {
      hottop: 5,
      trynew: 5,
      specialdiscount: 5,
      yangtaospecial: 3,
      groupbuy: 2,
      shippingfree: 3,
      sameascelebrity: 3,
      mustbuy: 3,
      choosegoodness: 3,
      globalCuisine: 3,
      goodBargains: 3,
      buyersSelection: 3
    }
    try{
      const res = await api.getAllThemes(data)
      this.specialThemeList = res.data||[]
      if(this.specialThemeList.length > 0) {
        this.hotTop = this.specialThemeList.find(item => item.themeType === 'hottop') || {} as SpecialThemeData
        this.tryNew = this.specialThemeList.find(item => item.themeType === 'trynew') || {} as SpecialThemeData
        this.specialDiscount = this.specialThemeList.find(item => item.themeType === 'specialdiscount') || {} as SpecialThemeData
        this.yangtaoSpecial = this.specialThemeList.find(item => item.themeType === 'yangtaospecial')   || {} as SpecialThemeData
        this.sameAsCelebrity = this.specialThemeList.find(item => item.themeType === 'sameascelebrity') || {} as SpecialThemeData
        this.globalCuisine = this.specialThemeList.find(item => item.themeType === 'globalCuisine')  || {} as SpecialThemeData
        this.goodBargains = this.specialThemeList.find(item => item.themeType === 'goodBargains')   || {} as SpecialThemeData
        this.buyersSelection = this.specialThemeList.find(item => item.themeType === 'buyersSelection')  || {} as SpecialThemeData
        this.groupBuy = this.specialThemeList.find(item => item.themeType === 'groupbuy')  || {} as SpecialThemeData
        this.mustBuy = this.specialThemeList.find(item => item.themeType === 'mustbuy')  || {} as SpecialThemeData
        this.shippingFree = this.specialThemeList.find(item => item.themeType === 'shippingfree')  || {} as SpecialThemeData
        this.chooseGoodness = this.specialThemeList.find(item => item.themeType === 'choosegoodness')  || {} as SpecialThemeData
      }
    }catch (e){
      this.isLoading = false
      console.log(e)
    }
  }

  public async getHomeBrand(){
    try {
      const res =  await api.getHomeBrand()
      this.brandList = res.data||[]
    }catch (e){
      console.log(e)
    }
  }
}

